import * as React from 'react';
import {cn} from '../lib/cn';

export function EmptyTitle({className, ...props}: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="empty-title"
      className={cn(
        'text-lg font-medium tracking-tight text-[var(--chekin-color-brand-navy)]',
        className,
      )}
      {...props}
    />
  );
}
